import React, { useState } from "react";
import ZoomInMapIcon from "@mui/icons-material/ZoomInMap";
import { Grid, AppBar } from "@mui/material";
import { Box, height, margin } from "@mui/system";
import { Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import SelfImprovementIcon from "@mui/icons-material/SelfImprovement";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import Select from "../utils/Select";
import {
  FOCUS_MODE,
  FREE_MODE,
  MUSIC_MODE,
  WORD_MODE_LABEL,
  SENTENCE_MODE_LABEL,
  GAME_MODE_DEFAULT,
  GAME_MODE_SENTENCE,
  TRAINER_MODE,
  WORDS_CARD_MODE,
  ULTRA_ZEN_MODE,
} from "../../constants/Constants";
import { Link } from "@mui/material";
import SupportMe from "../features/SupportMe";
import Inf from "../features/Inf";
import {
  GITHUB_TOOLTIP_TITLE,
  AUTHOR,
  GITHUB_REPO_LINK,
} from "../../constants/Constants";
import GitHubIcon from "@mui/icons-material/GitHub";
import KeyboardAltIcon from "@mui/icons-material/KeyboardAlt";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import EmojiFoodBeverageIcon from "@mui/icons-material/EmojiFoodBeverage";
import { ReactComponent as DiscordIcon } from "../../assets/Icons/mareege.svg";
import { SvgIcon } from "@mui/material";
import KeyboardAltOutlinedIcon from "@mui/icons-material/KeyboardAltOutlined";
import SchoolIcon from "@mui/icons-material/School";
import { Info, PaddingRounded } from "@mui/icons-material";

import { SOUND_MODE_TOOLTIP } from "../features/sound/sound";












const FooterMenu = ({
  themesOptions,
  theme,
  soundMode,
  toggleSoundMode,
  soundType,
  handleSoundTypeChange,
  soundOptions,
  handleThemeChange,
  toggleFocusedMode,
  toggleMusicMode,
  toggleUltraZenMode,
  isUltraZenMode,
  toggleCoffeeMode,
  isMusicMode,
  isFocusedMode,
  isCoffeeMode,
  gameMode,
  handleGameModeChange,
  isTrainerMode,
  toggleTrainerMode,
  isWordsCardMode,
  isWordGameMode,
  toggleWordsCardMode,
}) => {
  
  const isSiteInfoDisabled = isFocusedMode;
  const isBottomLogoEnabled = isFocusedMode;
  const isTypeTestEnabled = !isCoffeeMode && !isTrainerMode && !isWordsCardMode;

  const getModeButtonClassName = (mode) => {
    if (mode) {
      return "zen-button";
    }
    return "zen-button-deactive";
  };

  const getGameModeButtonClassName = (currMode, buttonMode) => {
    if (currMode === buttonMode) {
      return "active-game-mode-button";
    }
    return "inactive-game-mode-button";
  };


// Isticmaalka state si loogu maamulo furitaanka Tooltip-ka
const [open, setOpen] = useState(false);

// Xaalada taabashada ee moobiilka (touch device)
const isTouchDevice = window.matchMedia("(pointer: coarse)").matches;

// Xulashada in Tooltip-ka uu furmo marka la taabto
const handleTooltipClick = () => {
  if (isTouchDevice) {
    setOpen(prev => !prev); // Toggle on touch devices
  }
};

// Xulashada in Tooltip-ka uu furo marka mouse-ka la hoover gareeyo (desktop)
const handleTooltipOpen = () => {
  if (!isTouchDevice) {
    setOpen(true); // Furitaan Tooltip-ka
  }
};

// Xulashada in Tooltip-ka uu xirmo marka mouse-ka laga guuro (desktop)
const handleTooltipClose = () => {
  if (!isTouchDevice) {
    setOpen(false); // Xiritaan Tooltip-ka
  }
};



  return (
    <AppBar











    sx={{
      backgroundColor: '#ff5722', // Example: change background color
      padding: '0px 3px 0px 3px', // Example: add padding
      border: '0px solid', // Example: add a border
      borderRadius: '30px', // Example: Round the corners











    // Add more rules for other interactive elements if needed
  }}
    













      position="static"
      color="transparent"
      className={`bottomBar ${isFocusedMode && "fade-element"}`}
    >
      <Grid  container justifyContent="space-between" alignItems="center">
        <Box display="flex" flexDirection="row">

        <div style={{ margin: '0 3px' }} />

          <Select 
            classNamePrefix="Select"
            value={themesOptions.find((e) => e.value.label === theme.label)}
            options={themesOptions}
            isSearchable={false}
            isSelected={false}
            onChange={handleThemeChange}
            menuPlacement="top"
            

          ></Select>

<div style={{ margin: '0 4px' }} />




            <Select
              classNamePrefix="Select"
              value={soundOptions.find((e) => e.label === soundType)}
              options={soundOptions}
              isSearchable={false}
              isSelected={false}
              onChange={handleSoundTypeChange}
              menuPlacement="top"
            ></Select>
 
 

<div style={{ margin: '0 4px' }} />

              <IconButton>
                {" "}
                <span style={{ color: "#000000", marginBottom: "3px" }} className="menu-separator"> | </span>{" "}
              </IconButton>


            <IconButton
                onClick={() => {
                  handleGameModeChange(GAME_MODE_SENTENCE);
                }}
              >
                <span
                  className={getGameModeButtonClassName(
                    gameMode,
                    GAME_MODE_SENTENCE
                  )}
                >
                  {SENTENCE_MODE_LABEL}
                </span>
              </IconButton>

              
              
              <IconButton
                onClick={() => {
                  handleGameModeChange(GAME_MODE_DEFAULT);
                }}
              >
                <span
                  className={getGameModeButtonClassName(
                    gameMode,
                    GAME_MODE_DEFAULT
                  )}
                >
                  {WORD_MODE_LABEL}
                </span>
              </IconButton>

              <IconButton>
                {" "}
                <span style={{ color: "#000000", marginBottom: "3px"}} className="menu-separator"> | </span>{" "}
              </IconButton>


          <IconButton onClick={toggleFocusedMode}>
            <Tooltip title={FOCUS_MODE}>
              <span className={getModeButtonClassName(isFocusedMode)}>

<p style={{ fontSize: "13px", fontFamily: "exo", justifyContent: "center", marginBottom: "7px" }} >Diirad</p>

              </span>
            </Tooltip>
          </IconButton>



          <IconButton onClick={toggleCoffeeMode}>

               <Tooltip title={FREE_MODE}>
              <span className={getModeButtonClassName(isCoffeeMode)}>


              <p style={{ fontSize: "13px", fontFamily: "exo",justifyContent: "center", marginBottom: "7px" }} >Qoraal</p>

              </span>
            </Tooltip>
          </IconButton>
          <IconButton onClick={toggleTrainerMode}>
            <Tooltip title={TRAINER_MODE}>
              <span className={getModeButtonClassName(isTrainerMode)}>

              <p style={{ fontSize: "13px", fontFamily: "exo",justifyContent: "center", marginBottom: "7px" }} >Keyboard</p>

              </span>
            </Tooltip>
          </IconButton>
          <IconButton onClick={toggleMusicMode}>
            <Tooltip title={MUSIC_MODE}>
              <span className={getModeButtonClassName(isMusicMode)}>
              <p style={{ fontSize: "13px", fontFamily: "exo",justifyContent: "center", marginBottom: "7px" }} >Dhagaysi</p>

              </span>
            </Tooltip>{" "}
          </IconButton>
          {isTypeTestEnabled && (
            <>
            







            </>
          )}
        </Box>












        {!isSiteInfoDisabled && (
          <Box display="block" flexDirection="row">
            <Inf>
            </Inf>
            <SupportMe>
            </SupportMe>





            <Tooltip
  title={
    <span style={{ whiteSpace: "pre-line", fontSize: "12px" }}>
      {GITHUB_TOOLTIP_TITLE}
      <br />
      <Link
        style={{ color: "#ff5722", textDecoration: "underline" }}
        href="https://mareege.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        {AUTHOR}
      </Link>
    </span>
  }
  placement="top-start"
  open={open}
  onOpen={handleTooltipOpen}
  onClose={handleTooltipClose}
  componentsProps={{
    tooltip: {
      sx: {
        borderRadius: "30px",
        padding: "25px",
      },
    },
  }}
>
  <IconButton
    onClick={() => {
      if (isTouchDevice) {
        setOpen(prev => !prev); // Toggle Tooltip on touch devices
      } else {
        window.open("https://mareege.com/", "_blank", "noopener,noreferrer");
      }
    }}
    color="inherit"
    style={{
      cursor: "pointer",
    }}
  >
    <DiscordIcon width={28} height={28} />
  </IconButton>
</Tooltip>





          </Box>
        )}
        {isBottomLogoEnabled && (
          <Box display="block" flexDirection="row" className="bottom-info">
            <IconButton
  
            >
              <span style={{ fontSize: '18px', fontFamily: 'Exo', marginTop: "4px", fontWeight: 'bold', color: '#000000' }}>
                GARAACE 
              </span>
            </IconButton>
          </Box>
        )}
      </Grid>
    </AppBar>
  );
};

export default FooterMenu;
